import { useState } from 'react';
import './index.less';
import { useDialog } from '@/components/Dialog';
import { getUrlParams, UrlGovImg } from '@/utils';
import tab1 from '@/images/tab1.png';
import tab2 from '@/images/tab2.png';
import { Link } from 'react-router-dom';

export default function () {
  const [showDialog, Dialog] = useDialog();
  const [index, setIndex] = useState(1);
  const hasBack = getUrlParams('hasBack');
  return (
    <div className="whole">
      <div className="head">
        {!hasBack
          ? <Link to="/">
            <div className="back">返回首页</div>
          </Link>
          : <a className="back-btn" onClick={() => {
            window.history.back();
          }}>返回</a>
        }
      </div>

      <div className="main">
        <div className="main-head">
          <div
            className={index === 1 ? 'select' : ''}
            role="button"
            onClick={() => setIndex(1)}
          >
            关于超核玩家
          </div>
          <div
            className={index === 2 ? 'select' : ''}
            role="button"
            onClick={() => setIndex(2)}
          >
            仿冒案例
          </div>
        </div>
        {index === 1 && (
          <div className="tab-1">
            <img className="home-logo" src={tab1} alt="" />
          </div>
        )}
        {index === 2 && (
          <div className="tab-2">
            <img className="home-logo" src={tab2} alt="" />
          </div>
        )}
      </div>

      <div className="foot">
        <div className="foot-head">
          <div className="slide4-text-wrapper">
            <p>关注我们</p>
            <p>官方网站：https://supercore.qq.com </p>
            <p>官方邮箱：SuperCorePlayer@tencent.com</p>
          </div>
          <div className="foot-main">
            <div className="network-supervisor">
              <div className="network-supervisor-image">
                <UrlGovImg />
              </div>
              <div className="desc">
                <p className="txt">工商网监</p>
                <p className="txt">电子标识</p>
              </div>
            </div>
            <div className="text">
              <p>全国官方客服 +86 9509 2888</p>
              <p>服务时间 7*24小时</p>
            </div>
          </div>
        </div>
        <div className="slide4-business-text">
          <p>
            <a href="https://ieg.tencent.com/"> 腾讯互娱 </a>
            {' '}
            /
            {' '}
            <a href="https://careers.tencent.com/"> 加入我们 </a>
            {' '}
            /
            {' '}
            <a role="button" onClick={showDialog}>
              商务合作
            </a>
            /
            {' '}
            <a role="button" onClick={showDialog}>
              联系我们
            </a>
            /
            {' '}
            <a href="https://game.qq.com/contract_software.shtml"> 用户协议 </a>
            /
            <a href="https://privacy.qq.com/"> 隐私政策 </a>
            {' '}
            /
            {' '}
            <a href="https://privacy.qq.com/privacy-children.htm">
              儿童隐私保护声明
            </a>
          </p>
          <p>
            COPYRIGHT © 1998 – 2020 TENCENT. ALL RIGHTS RESERVED. 腾讯公司
            版权所有
          </p>
        </div>
        <Dialog />
      </div>
    </div>
  );
}
